import { useEffect, useState } from 'react';

/**
 * Returns `value` debounced by `delay` ms. Use to feed a typed search box into
 * a TanStack Query key without firing a request on every keystroke.
 *
 *   const [search, setSearch] = useState('');
 *   const debouncedSearch = useDebouncedValue(search, 300);
 *   const params = useMemo(() => ({ q: debouncedSearch, ... }), [debouncedSearch, ...]);
 */
export default function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}
